import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { delay, startsWith } from 'lodash';
import { toast } from 'react-toastify';

// Import Selectors
import { getUserCurrentOrganization } from '../../modules/Auth/AuthReducer';

import { getHideSyncToast } from '../../modules/App/AppReducer';
import { hideSyncToast, unhideSyncToast, shouldShowSyncToast, shouldHideSyncToast } from '../../modules/App/AppActions';
import SyncProgress from './progress';

class SyncToaster extends Component {
  constructor(props) {
    super(props);
    const { pathname } = props.location;
    this.state = {
      pathname,
      isSetupSection: startsWith(pathname, '/setup'),
      isAdminSection: startsWith(pathname, '/admin'),
      isNewsSection: startsWith(pathname, '/news'),
    };
  
    this.handleToastClose = this.handleToastClose.bind(this);
    this.handleToastOpen = this.handleToastOpen.bind(this);
    delay(() => {
      this.checkToast();
    }, 500);
  }

  componentDidUpdate(prevProps) {
    const prevOrg = prevProps.organization || {};
    const currentOrg = this.props.organization || {};
    if (
      prevProps.location.pathname !== this.props.location.pathname || 
      prevProps.toastClosed !== this.props.toastClosed || 
      prevOrg._id !== currentOrg._id ||
      prevOrg.syncing !== currentOrg.syncing
    ) {
      const { pathname } = this.props.location;
      const isSetupSection = startsWith(pathname, '/setup');
      const isAdminSection = startsWith(pathname, '/admin');
      const isNewsSection = startsWith(pathname, '/news');
      this.setState({ pathname, isSetupSection, isAdminSection, isNewsSection }, () => {
        this.checkToast();
      });
      
      if (prevProps.location.pathname !== this.props.location.pathname) {
        this.props.dispatch(unhideSyncToast());
      }
    }
  }

  handleToastClose() {
    this.props.dispatch(hideSyncToast());
    this.props.onSyncToasterClose();
  }

  handleToastOpen() {
    this.props.onSyncToasterOpen();
  }


  checkToast() {
    const { organization, toastClosed } = this.props;
    const { isSetupSection, isAdminSection, isNewsSection } = this.state;
    if (toastClosed) {
      return;
    }
    const lastSyncedDate = organization ? organization.last_synced_date : false;
    const syncing = organization ? organization.syncing : false;
    if (syncing && !isSetupSection && !isAdminSection && !isNewsSection && lastSyncedDate !== null && lastSyncedDate !== undefined) {
      this.context.addNotification(<div key={organization._id}><p><strong>Syncing:</strong></p><SyncProgress mini /></div>, { autoClose: false, toastId: 'sync', onClose: this.handleToastClose, onOpen: this.handleToastOpen });
    } else {
      toast.dismiss();
    }
    if (!syncing) {
      toast.dismiss();
    }
    if (isSetupSection || isAdminSection || isNewsSection) {
      this.props.dispatch(shouldShowSyncToast());
    } else {
      this.props.dispatch(shouldHideSyncToast());
    }
  }

  render() {
    return null;
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
    toastClosed: getHideSyncToast(state),
  };
}

SyncToaster.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string,
    syncing: PropTypes.bool,
    is_demo: PropTypes.bool,
    last_synced_date: PropTypes.string,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  toastClosed: PropTypes.bool,
  onSyncToasterClose: PropTypes.func,
  onSyncToasterOpen: PropTypes.func,
};

SyncToaster.defaultProps = {
  toastClosed: false,
  onSyncToasterClose: () => {},
  onSyncToasterOpen: ()  => {},
};

SyncToaster.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps)(SyncToaster));
